<template>
  <div class="wrapper">
    <inline-field-actions :schema="schema"></inline-field-actions>
  	<textarea class="form-control"
  		v-model="value"
  		:id="getFieldID(schema)"
  		:disabled="disabled"
  		:maxlength="schema.max"
  		:minlength="schema.min"
  		:placeholder="schema.placeholder"
  		:readonly="schema.readonly"
  		:rows="schema.rows || 2"
  		:name="schema.inputName"
      @change="handleChange">
    </textarea>
  </div>
</template>

<script>
  import { abstractField } from 'vue-form-generator';
  import { mapMutations } from 'vuex';

  export default {
    mixins: [abstractField],

    methods: {
      ...mapMutations('admin', [
        'setFormChanged',
      ]),

      handleChange() {
        this.setFormChanged(true);
      },
    },
  };
</script>
